import { useEffect, useState, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { useSelector, useDispatch } from "react-redux";
import { getHsCode } from "../../Actions/HSCodeAction";
import { globalStyle } from "../../global/Utils";
import { Box, Modal, Button } from "@mui/material";
import { isUndefined } from "lodash";

const OpenHsModal = ({ open, onClose, setFormData }) => {
  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [globalFilter, setGlobalFilter] = useState("");

  const isGettingHsCodeList = useSelector(
    (state) => state.HsCodeListReducer?.isGettingHsCodeList,
  );
  const hsCodeList = useSelector(
    (state) => state.HsCodeListReducer?.hsCodeList || [],
  );
  const totalResults = useSelector(
    (state) => state.HsCodeListReducer.totalResults || 0,
  );

  useEffect(() => {
    dispatch(
      getHsCode(pagination.pageIndex, pagination.pageSize, globalFilter),
    );
  }, [pagination, dispatch, globalFilter]);

  // Define table columns
  const columns = useMemo(
    () => [
      {
        accessorKey: "_id",
        header: "#",
        size: 40,
        enableResizing: false,
        enableEditing: false,
        Cell: ({ row }) =>
          row.index + 1 + pagination.pageIndex * pagination.pageSize, // serial number considering pagination
      },
      {
        accessorKey: "pctCode",
        header: "HS Code",
        size: 50,
        grow: false, // fixed width
      },
      {
        accessorKey: "description",
        header: "Description",
        grow: true, // takes remaining space
        enableEditing: false,
      },
      {
        id: "actions",
        header: " Actions",
        grow: false,
        size: 50,
        enableEditing: false,
        Cell: ({ row }) => (
          <Button
            onClick={() => {
              setFormData((prev) => ({
                ...prev,
                HSCodeId: row.original._id,
                HSCodeName: row.original.pctCode,
              }));
              onClose();
            }}
            variant="contained"
            color="primary"
          >
            Select HS
          </Button>
        ),
      },
    ],
    // eslint-disable-next-line
    [pagination],
  );
  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
      }}
      sx={{
        zIndex: 1500, // important when using Drawer
      }}
    >
      <Box
        sx={{
          maxHeight: "80vh",
          overflowY: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 1200,
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: 24,
          p: 2,
        }}
      >
        <MaterialReactTable
          columns={columns}
          data={hsCodeList}
          manualPagination
          rowCount={totalResults}
          state={{
            showGlobalFilter: true,
            isLoading: isGettingHsCodeList,
            pagination,
          }}
          onGlobalFilterChange={(value) =>
            isUndefined(value) ? setGlobalFilter("") : setGlobalFilter(value)
          }
          columnFilterDisplayMode={false}
          onPaginationChange={setPagination}
          muiTableBodyRowProps={{
            sx: {
              cursor: "pointer",
              "&:hover": {
                backgroundColor: globalStyle.bgColor,
              },
            },
          }}
          muiTablePaperProps={{
            sx: {
              backgroundColor: globalStyle.bgColorWhite,
              borderRadius: `${globalStyle.borderRadius}px`,
            },
          }}
        />
      </Box>
    </Modal>
  );
};

export default OpenHsModal;
